export default `
try {
  window.digitalData = {
    page: {
      pageInfo: {
        pageName: 'home',
      },
    },
    siteInfo: {
      site: 'player',
    },
    user: {
      deviceId: window.navigator.userAgent,
      loggedIn: 0,
      userId: 'n/a',
      location: 'n/a',
      personalisationStatus: '0',
      vipStatus: '0',
    },
    vrs: {
      product: 'player',
      platform: 'responsiveweb',
    },
    campaign: 'n/a'
  };
  var matchUserCookie = document.cookie.match(/STV_USERID=([^;]+)/);
  if (matchUserCookie) {
    window.digitalData.user.userId = matchUserCookie[1];
    window.digitalData.user.loggedIn = '1';
  }
  var matchOptInCookie = document.cookie.match(/STV_PERSONALISATION_OPTIN=([^;]+)/);
  if (matchOptInCookie && matchUserCookie) {
    if(matchOptInCookie[1] !== 'false'){
      window.digitalData.user.personalisationStatus = '1';
    }
  } else {
    window.digitalData.user.personalisationStatus = '0';
  }
  var matchOptInCookie = document.cookie.match(/STV_VIP_OPTIN=([^;]+)/);
  if (matchOptInCookie && matchUserCookie) {
    if(matchOptInCookie[1] === 'true'){
      window.digitalData.user.vipStatus = '1';
    }
  } else {
    window.digitalData.user.vipStatus = '0';
  }
  var matchGrouptokenCookie = document.cookie.match(/STV_GROUPTOKEN=([^;]+)/);
  if (matchGrouptokenCookie) {
    var broadcastRegionInt = parseInt(matchGrouptokenCookie[1][2]);
    if (broadcastRegionInt >= 4 && broadcastRegionInt <=7 ) {
      window.digitalData.user.broadcastRegion = 'stv-region'
    } else if (broadcastRegionInt >= 1 && broadcastRegionInt <= 3) {
      window.digitalData.user.broadcastRegion = 'itv-region'
    }
  }
  var matchPlayerPlusCookie = document.cookie.match(/STV_PLAYER_PLUS=([^;]+)/);
  if (matchPlayerPlusCookie) {
    var playerPlusCookie = JSON.parse(decodeURIComponent(matchPlayerPlusCookie[1]))
      window.digitalData.user.playerPlusStatus = (playerPlusCookie['currentlySubscribed'] === true) ? '1' : '0'
      window.digitalData.user.playerPlusIsTrial = (playerPlusCookie['isTrial'] === true) ? '1' : '0'
      window.digitalData.user.playerPlusUsedTrial = (playerPlusCookie['usedTrial'] === true) ? '1' : '0'
      window.digitalData.user.subscriptionStatus = (playerPlusCookie['subscriptionType'] === null) ? 'free' : ((playerPlusCookie['subscriptionType'] === 'plus') ? 'player+' : 'player+ PS')
  } else {
    window.digitalData.user.playerPlusStatus = '0'
    window.digitalData.user.playerPlusIsTrial = '0'
    window.digitalData.user.playerPlusUsedTrial = '0'
    window.digitalData.user.subscriptionStatus = 'free'
  }
  var matchCid = window.location.search.match(/[&?]cid=([^&]+)/);
  if (matchCid) {
    window.digitalData.campaign = matchCid[1];
  }
  window.digitalData.registration = window.digitalData.registration || {};
  window.dataLayer = [];
} catch (e) {
  console.log('Could not parse Adobe Analytics params.', e);
}
`
